import React from 'react'
import { connect } from 'react-redux'
import { showModal } from '../actions/modal'

import EmailCampaign from './campaigns/EmailCampaign'
import SocialCampaign from './campaigns/SocialCampaign'
import SMSCampaign from './campaigns/SMSCampaign'
import PushCampaign from './campaigns/PushCampaign'

import './CampaignsMenu.css'

class Menu extends React.Component {
  state = {
    showMenu: false,
  }

  toggleMenu = (ev) => {
    this.setState({ showMenu: !this.state.showMenu });
  }

  showMenu = (ev) => {
    this.setState({ showMenu: true });
  }

  closeMenu = (ev) => {
    this.setState({ showMenu: false });
  }
  
  render() {
    const { className } = this.props;
    const menu = this.state.showMenu ? 'menu menu--show' : 'menu';
    const menu__content = className ? `menu__content ${className}` : 'menu__content';
    const MenuButton = this.props.button;
    return (
      <div className={menu} onBlur={this.closeMenu} tabIndex="0">
        <div className="menu__button" onClick={this.toggleMenu}>
          <MenuButton/>
        </div>
        <div className={menu__content} onClick={this.closeMenu}>
          {this.props.children}
        </div>
      </div>
    )
  }
}

const Button = () => (
  <div>Start Campaign</div>
)

// const CampaignsMenu = (props) => (
//   <Menu button={Button}>
//     <div className="menu__item" 
//       onClick={() => props.showModal(SocialCampaign)}>Social</div>
//     <div className="menu__item" 
//       onClick={() => props.showModal(EmailCampaign)}>Email</div>
//     <div className="menu__item" 
//       onClick={() => props.showModal(SMSCampaign)}>SMS</div>
//     <div className="menu__item" 
//       onClick={() => props.showModal(PushCampaign)}>Push</div>
//   </Menu>
// )

const CampaignsMenu = (props) => (
  <Menu button={Button}>
    <div className="cpm-other">
      <div className="cpm__item" 
        onClick={() => props.showModal(EmailCampaign)}>Email</div>
      <div className="cpm__item"
        onClick={() => props.showModal(PushCampaign)}>Push</div>
      <div className="cpm__item"
        onClick={() => props.showModal(SMSCampaign)}>SMS</div>
    </div>
    <div className="cpm-social">
      <div className="cpm__item cpm__item--social fa fa-fb"
        onClick={() => props.showModal(SocialCampaign)}>Facebook</div>
      <div className="cpm__item cpm__item--social fa fa-ig">Instagram</div>
      <div className="cpm__item cpm__item--social fa fa-tw">Twitter</div>
      <div className="cpm__item cpm__item--social fa fa-go">Google</div>
      <div className="cpm__item cpm__item--social fa fa-yt">Youtube</div>
      <div className="cpm__item cpm__item--social fa fa-sc">Snapchat</div>
      <div className="cpm__item cpm__item--social fa fa-sp">Spotify</div>
    </div>
  </Menu>
)



export default connect(null, { showModal })(CampaignsMenu)


// WEBPACK FOOTER //
// ./src/components/CampaignsMenu.js